{
  "duration-form": {
    "text": {
      "hour": "Stunde",
      "minute": "Minute"
    }
  }
}
